import React, { useState } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import CSVReader from 'react-csv-reader';
import { FormApi } from 'final-form';
import { CGCardConfigFormValues } from 'types/cardForm';
import { isValidPhoneNumber, isRequired, isValidEmail, isValidMessage } from 'utilities/regEx';
interface BulkCsvUploadButtonProps {
  onFileLoaded?: (content: any, fileInfo: any) => void;
  label?: string;
}
const papaparseOptions = {
  header: true,
  dynamicTyping: true,
  skipEmptyLines: true,
  transformHeader: (header: any) => header.toLowerCase().replace(/\W/g, '_'),
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    uploadButton: {
      border: '1px solid ' + theme.palette.primary.main,
      padding: theme.spacing(0.5, 1.5),
      borderRadius: 25,
      '& > span': {
        fontSize: 14,
      },
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(0.5, 5),
      },
    },
  }),
  { name: 'BulkCsvUploadButton' },
);

const BulkCsvUploadButton: React.FC<BulkCsvUploadButtonProps> = ({ label = 'Upload File', onFileLoaded, ...rest }) => {
  //to reset the value of the input to upload more than once
  const [refresh, setRefresh] = useState<boolean>(true);

  const classes = useStyles();

  const handleForce = (content: any, fileInfo: any) => {
    if (onFileLoaded) onFileLoaded(content, fileInfo);
    setRefresh((refresh: boolean) => !refresh);
  };
  return (
    <>
      {refresh && (
        <FormControlLabel
          className={classes.uploadButton}
          control={<CSVReader cssClass="react-csv-input" onFileLoaded={handleForce} parserOptions={papaparseOptions} inputStyle={{ display: 'none' }} />}
          label={`Upload File`}
          {...rest}
        />
      )}

      {!refresh && (
        <FormControlLabel
          className={classes.uploadButton}
          control={<CSVReader cssClass="react-csv-input" onFileLoaded={handleForce} parserOptions={papaparseOptions} inputStyle={{ display: 'none' }} />}
          label={`Upload File`}
          {...rest}
        />
      )}
    </>
  );
};

export default BulkCsvUploadButton;

const isValidRow = (row: any) => {
  if (!row) return false;
  if (isRequired(row.email) !== undefined || isValidEmail(row.email) !== undefined) return false;
  if (isRequired(row.name) !== undefined) return false;
  if (isValidPhoneNumber(row.phone) !== undefined) return false;
  if (isValidMessage(row.message) !== undefined) return false;
  return true;
};

const phoneToString = (phone: number | string) => {
  let p = phone?.toString() || '';
  //auto fill the leading zero missing
  if (p.length === 9) {
    p = '0'.repeat(10 - p.length) + phone;
  }
  return p;
};

export const handleFileLoaded =
  (
    //
    form: FormApi<CGCardConfigFormValues, Partial<CGCardConfigFormValues>>,
    values: any,
    showMessage: any,
  ) =>
  (content: any, fileInfo: any) => {
    let errors: number[] = [];
    let validRows: any[] = [];
    content
      .map((row: any) => ({ ...row, phone: phoneToString(row.phone) }))
      .forEach((row: any, index: number) => {
        if (!isValidRow(row)) {
          errors.push(index + 2);
        } else if (errors.length === 0) {
          validRows.push({ ...row, bulk: true });
        }
      });

    if (errors.length) {
      showMessage(`Unexpected upload error. Please check data in rows ${errors.join(', ')}`, 'error');
    } else {
      let recipients = values.recipients || [];

      recipients = [
        ...validRows,
        ...recipients.filter(
          (recipient: any) =>
            // @ts-ignore
            recipient.bulk !== true,
        ),
      ];
      form.change('recipients', recipients);
    }
  };
